import React from 'react'
import { RFPContext, useRFPState } from '../../contexts'
import { RFPDashboard } from './RFPDashboard'

interface RFPRootProps {
    folio?: boolean
}

export const RFPRoot = (props: RFPRootProps) => {
    const rfpState = useRFPState()

    return (
        <RFPContext.Provider value={rfpState}>
            <RFPDashboard folio={props.folio} />
        </RFPContext.Provider>
    )
}

export const OrganizationRFPRoot = () => <RFPRoot folio />
